import setCommonHeaders from '@/src/utils/rtkQuery/setCommonHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

interface TagItem {
    icon: string
    prioritySort?: boolean
    code: string
    status: boolean
    targetLink: string
    sequence: number
    isRT: boolean
    isOW: boolean
    _id: string
    domain: string[]
    heyaApplicable?: boolean
    en: {
        heading: string
        description: string
    }
    ar: {
        heading: string
        description: string
    }
}

interface FilteredInfo {
    expired: string[]
    inactive: string[]
    totalFiltered: number
}

interface TagsApiResponse {
    tags: TagItem[]
    message: string
    filtered: FilteredInfo
}

interface TagsResponse {
    message: string
    tags: TagsApiResponse
}

interface TagsQueryParams {
    domain?: string
    isRT?: boolean
    isOW?: boolean
    intl?: boolean
    dom?: boolean
    heyaApplicable?: boolean
}

const tagsApi = createApi({
    reducerPath: 'tagsApi',
    baseQuery: fetchBaseQuery({
        prepareHeaders: headers => {
            return setCommonHeaders(headers)
        }
    }),
    endpoints: builder => ({
        getTags: builder.query<TagItem[], TagsQueryParams>({
            query: params => {
                const queryParams = new URLSearchParams()

                if (params.domain) queryParams.append('domain', params.domain)
                if (params.isRT) queryParams.append('isRT', 'true')
                if (params.isOW) queryParams.append('isOW', 'true')
                if (params.intl) queryParams.append('intl', 'true')
                if (params.dom) queryParams.append('dom', 'true')
                if (params.heyaApplicable) queryParams.append('heyaApplicable', 'true')
                queryParams.append('isSrp', 'true')

                return `/node/flight/tags?${queryParams.toString()}`
            },
            transformResponse: (response: TagsResponse, meta, arg) => {
                // Extract tags from the new nested structure
                const tagItems = response?.tags?.tags || []
                if (tagItems.length === 0) return []

                // Filter based on isRT/isOW parameters
                let filteredTags = tagItems.filter(item => {
                    // Check if tag matches isRT/isOW criteria
                    if (arg.isRT && !item.isRT) return false
                    if (arg.isOW && !item.isOW) return false
                    return true
                })

                // Tags are already filtered by status on the backend
                // Sort by sequence
                return filteredTags.sort((a, b) => a.sequence - b.sequence)
            }
        })
    })
})

export const { useGetTagsQuery, useLazyGetTagsQuery } = tagsApi
export default tagsApi
export type { TagItem, TagsQueryParams }
